import { adminClient } from '@neptune/shared/core-apis-admin-domain';

export const uploadLicense = async (newLicense: string): Promise<void> => {
  return adminClient.setLicense({
    license: {
      license: newLicense,
    },
  });
};
